/** All in-app Outreach tab routes (must stay in sync with OutreachNav). */
export const OUTREACH_APP_PATHS = [
  '/app/outreach/campaigns',
  '/app/outreach/campaign-histories',
  '/app/outreach/lists',
  '/app/outreach/contacts',
  '/app/outreach/keywords',
  '/app/outreach/categories',
  '/app/outreach/mkt-content',
  '/app/outreach/mkt-sender-emails',
  '/app/outreach/form-fields',
  '/app/outreach/import',
  '/app/outreach/attributes',
];

export function mergeOutreachMenuPaths(menuPaths) {
  const paths = Array.isArray(menuPaths) ? [...menuPaths] : [];
  const hasOutreachAccess = paths.some(
    (path) => typeof path === 'string' && path.startsWith('/app/outreach')
  );
  if (!hasOutreachAccess) return paths;

  const merged = new Set(paths);
  OUTREACH_APP_PATHS.forEach((path) => merged.add(path));
  return [...merged];
}
